@if (isItemRestricted()) {
  <p class="restricted-message" [attr.data-selector]="dataSelector + '-restricted-message'">This response is restricted and cannot be viewed or modified.</p>
} @else if (isEditingAllowed()) {
  <awn-upload-files
    [disabled]="readonly()"
    [disabledStyling]="readonly()"
    [accept]="acceptedFileTypes"
    [entityId]="jobId$ | async"
    [hasError]="hasEmptyDocumentError()"
    (onFileUploadStart)="onUploadFilesStart($event)"
    (onFileUploadEnd)="onUploadFilesComplete($event)"
    [dataSelector]="dataSelector + '-upload-files'"
  ></awn-upload-files>
}

<div class="file-list" [dataSelector]="dataSelector + '-file-list'">

  @for (fileJobId of stagedFilesForThisDocumentIds(); track fileJobId) {
    <awn-file-upload-job-item class="file-item" [jobId]="fileJobId"></awn-file-upload-job-item>
  }

  @for(file of files(); track file.id; let i = $index) {
    <awn-file-item
      class="file-item"
      [file]="file"
      [fileIndex]="i"
      [siblingFiles]="files()"
      [documentItem]="documentItem()"
      [isEditingAllowed]="isEditingAllowed()"
      [instance]="instance()"
      [dataSelector]="dataSelector + '-file-item-' + i"
    ></awn-file-item>
  }
</div>
